import { notify } from "../../../../utils/notify";
import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

const multitenantHeaders = new Headers();
multitenantHeaders.append("Authorization", token);
multitenantHeaders.append("content-type", "application/json");

export async function getSeries({
  companyId,
  isProduction = null,
  model = "",
}) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const customerPath = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/empresa/${companyId}/configuration/serie/emission`;
  const url = new URL(customerPath);

  url.searchParams.append("model", model);

  if (isProduction || isProduction === 0)
    url.searchParams.append("isProduction", isProduction);

  return search(decodeURIComponent(url), "GET", multitenantHeaders);
}
